import React, { useState,useEffect } from 'react';
import { connect } from 'react-redux';
import { deleteUser,getOrg ,deleteOrg} from "../../../Redux/actions/organization";
import { checkPayment } from "../../../Redux/actions/billingPayment";
import { addNotification } from "../../../Utilities/notifications";
import EmptyScreen from "../../../Assets/Empty-Screen.png";
import empty_profile from "../../../Assets/emptyimage.png";
import CustomModal from "../../../UtilityComponents/customModal";
import DeleteOrg from "./deleteOrg";
import "./index.css";
import CreateOrg from './createOrg';

function Organization(props) {
  
    let { user, organizations, history} = props;
    const [org,setOrg] = useState([])
    const [deleteOrgModal, setDeleteOrgModal] = useState(false);
    const [leaveOrgModal, setLeaveOrgModal] = useState(false);
    const [createModal,setCreateModal] = useState(false)
    const [search_data,setsearch_data] = useState()
    const [data,setData] = useState([])
    document.title = "Organization | E-Manager Console | Techforce.ai";
    const toggle = async(obj)=>{      
      if(obj)
      setData(obj)   
      if(user.sub === obj.created_by){
        setDeleteOrgModal(!deleteOrgModal) 
      }
      else{
        setLeaveOrgModal(!leaveOrgModal)
      }
    }
    
     const createOrgModal = async(obj)=>{ 
      setCreateModal(!createModal) 
      reloadProcess()
     }
    
    useEffect(() => {
      const fetchData = async () => {
        let data = await getOrg();      
        setOrg(data)
      };
      fetchData();
    }, [organizations.data]);
    
    const reloadProcess = React.useMemo(() => {
      return async event => {
        let data = await getOrg();      
        setOrg(data)
      };
    },[]);

    const handleClick = async() => {
          createOrgModal()
    }

    const fetchData = async () => {    
      let data = await getOrg();
      if (data.length > 0) {
        setOrg(data);
      }
    };  

    const handleLeave = async () => {   
      setLeaveOrgModal(!leaveOrgModal)    
        await deleteUser(user.sub, data.id);
        reloadProcess()
      
    }

    const handleDelete = async () => {   
      setDeleteOrgModal(!deleteOrgModal) 
      if(data.created_by === user.sub){
        await deleteOrg(data.id,data.role_id);
        reloadProcess()
      }
    }

    const handleChange = (e) =>{    
      setsearch_data(e.target.value)
      if(e.target.value.length === 0){
        setsearch_data(null)
        fetchData()
      }
    }
    
     const handleSearch = async () =>{
      if(search_data){        
          let data = org.find((obj) => obj.display_name.toString() === search_data);      
          if(data){
              setOrg([data])
          } else{
              setOrg([])
          }
      }else{
          let data = await getOrg();
          if (data.length > 0) {
           setOrg(data);
          }
      }
    }

    const keyPress = async(e) => {
      if (e.key === 'Enter' ){
        handleSearch()
      }
    }

    const compare = (a, b) => {
      var nameA=a.created_at
      var nameB=b.created_at
      if (nameA < nameB) 
       return 1;
      if (nameA > nameB)
       return -1;
      return 0; 
    };
  console.log(organizations.data)
    return (
      <div className="organizations-container">
        <div className="organizations-header">
          <h5>Organizations</h5>
          <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"240px",padding:"8px",marginTop:"7px"}}></i>
          <input type="text"  name="search_data" onChange={handleChange} onKeyPress={keyPress} placeholder="Search" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"95px"}}/>
          <button className="btn" onClick={handleClick}>
            Create
          </button>
        </div>
        <div >
          {organizations.data.length > 0 ? (
            <div className="org-cards">
              {org.sort(compare).map((organization, index) => { 
                return (
                  <div key={index} className="card text-center">
                    <div className="card-body ">
                    <img 
                src={organization.profile_pic ? organization.profile_pic : empty_profile}
                className="rounded mx-auto d-block"
                alt="..." 
              />
                      <h3><div>{organization.display_name}</div></h3>
                      <label>{organization.created_at.split("T")[0]}</label>
                    </div>
                    <div
                      style={{ backgroundColor: "transparent" }}
                      className="card-footer"
                    >
                      <button
                        className="btn"
                        onClick={() =>
                          history.push(
                            `/organizations/${organization.display_name}/settings`
                          )
                        }
                        disabled={organization.role_id === 1 ? false : true}
                      >
                        Settings
                      </button>
                      <button
                        className="btn"
                        onClick={() => toggle(organization)}
                      >
                        {user.sub === organization.created_by ? "Delete" : "Leave"}
                      </button>
                    </div>
                    
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center">
              <img
                src={EmptyScreen}
                alt="empty Screen"
                style={{margin:"15px 0px"}}
              ></img>
              <h4>You don't have any organizations assigned yet.</h4>
              <p>Please create organization</p>
            </div>
          )}
        </div>
             <div>
                   {createModal ?<CustomModal comp={<CreateOrg   toggle={() => createOrgModal()} />}
                        toggle={()=>createOrgModal()}
                        name="Tell us about your organization"
                        modal={createModal}/>:null}
             </div>
             <div>
                   {deleteOrgModal ?<CustomModal comp={<DeleteOrg deleteOrg = {()=>handleDelete()}  toggle={() => toggle()} />}
                        name={`If u want to delete ${data.display_name} organization then related Action flows,Eworkers etc will be deleted ?`}
                        toggle={()=>toggle()}
                        modal={deleteOrgModal}/>:null}
             </div>
             <div>
                   {leaveOrgModal ?<CustomModal comp={<DeleteOrg deleteOrg = {()=>handleLeave()}  toggle={() => toggle()} />}
                        name={`Are you sure you want to leave from Organization ${data.display_name} ?`}
                        toggle={()=>toggle()}
                        modal={leaveOrgModal}/>:null}
             </div>

      </div>
    );
}
const mapStateToProps = (state) => ({
   user: state.user,
    organizations: state.organizations, 
  
}
);

export default connect(mapStateToProps, null)(Organization)